<template>
  <a-modal
    v-model="visible"
    :title="
      category ? `Cập nhật ngành nghề ${category.name}` : 'Thêm mới ngành nghề'
    "
    :maskClosable="false"
    @cancel="handleClose"
  >
    <a-form-model :model="form" :rules="rules" ref="form">
      <a-form-model-item class="mb-5" label="Tên ngành nghề" prop="name">
        <a-input v-model="form.name" placeholder="Tên ngành nghề" />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleClose"> Đóng </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="callingAPI"
        @click="handleSubmit"
      >
        Submit
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import {
  createCategory,
  updateCategory,
} from "@/services/landing-page/career/career-category";
export default {
  name: "ControllerCareerCategory",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      callingAPI: false,
      form: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    visible() {
      if (this.category) {
        this.form.name = this.category.name;
      }
    }
  },
  methods: {
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            const data = {
              name: this.form.name,
              image: null,
              status: this.category ? this.category.status : 1
            }
            if (this.category) {
              await updateCategory(this.category.id, data);
            } else {
              await createCategory(data);
            }
            this.callingAPI = false;
            this.$emit('reload')
            
            let message;
            message = this.category
              ? "Cập nhật thành công"
              : "Thêm mới thành công";
            this.$notification.success({
              message: "Thành công",
              description: message,
            });
          } catch (error) {
            console.log(error);
            this.callingAPI = false
            let message = this.category
              ? "Cập nhật thất bại"
              : "Thêm mới thất bại";
            this.$notification.error({
              message: "Thất bại",
              description: message,
            });
          }
        }
      });
    },

    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>